export default "__VITE_ASSET__b4853a2b__"